import { gql } from "graphql-request";

// "Warnings on route": the alerts along a saved hike (overview page, map hike
// card) or an unsaved planner route. A small query of its own, fetched after
// the page has loaded and never part of the cached hike queries, so the
// warnings are always fresh and page caching/SEO are untouched. Both work
// signed out. Alerts arrive ordered (danger first, then by distance along the
// route) — render them in that order. Difficult sections (kind
// DIFFICULT_TERRAIN) carry their SAC grade, where they start and end along the
// route and their geometry; hazards leave those null. `alerts` is every warning
// (the maps draw all of them); `cards` is what the lists show: one per hazard
// type / SAC grade, its first alert plus how many more the group has.
const ALERT_FIELDS = `
    id
    kind
    level
    latitude
    longitude
    distanceAlongRouteM
    distanceFromRouteM
    sacGrade
    startAlongRouteM
    endAlongRouteM
    lengthM
    encodedPolyline
    hazard {
      id
      hazardType
      passability
      confirmationState
      status
    }
`;

const ROUTE_ALERT_FIELDS = `
  count
  alerts {${ALERT_FIELDS}  }
  cards {
    moreCount
    groupKey
    alert {${ALERT_FIELDS}    }
  }
`;

// Null when the hike isn't visible to the viewer.
export const GetRouteAlertsForHike = gql`
  query GetRouteAlertsForHike($hikeId: ID!) {
    routeAlertsForHike(hikeId: $hikeId) {${ROUTE_ALERT_FIELDS}}
  }
`;

// One Google encoded polyline (precision 5, lat/lng) per route part, in order,
// and optionally each rated part's GraphHopper hike_rating ranges
// ({ part, ranges: [[fromPoint, toPoint, rating]] }) over the points sent.
export const GetRouteAlertsForRoute = gql`
  query GetRouteAlertsForRoute($encodedPolylines: [String!]!, $hikeRatings: [RoutePartHikeRatingsInput!]) {
    routeAlertsForRoute(encodedPolylines: $encodedPolylines, hikeRatings: $hikeRatings) {${ROUTE_ALERT_FIELDS}}
  }
`;
